

















































import { Vue, Component } from 'vue-property-decorator';
import Utils from '../utils/utils';
import { AppStore } from '@/store/modules/app';
import { UserStore } from '@/store/modules/user';

@Component
export default class AppToolBar extends Vue {
  items: Array<object> = [
    {
      icon: 'person',
      href: '#',
      title: '个人中心',
      click: (e: any) => {
        this.$parent.$router.push('/personalCenter');
        //UserStore.FedLogOut();
        // this.$parent.$router.push('/login');
        // (window as any).getApp.$emit('APP_PERSONAL_CENTER');
      }
    },
    {
      icon: 'logout',
      href: '#',
      title: '退出登录',
      click: (e: any) => {
        UserStore.FedLogOut();
        this.$parent.$router.push('/login');
        ///(window as any).getApp.$emit('APP_LOGOUT');
      }
    }
  ];

  /**获取用户名称 */
  get getUserName() {
    return UserStore.name;
  }

  /**获取用户头像 */
  get getUserAvatar() {
    return UserStore.avatar;
  }

  /**缩小和展开侧边栏 */
  handleDrawerToggle() {
    AppStore.ToggleSideBar();
  }

  /**全屏 */
  handleFullScreen() {
    Utils.toggleFullScreen();
  }
}
